import { Button, Container, Table } from '@mantine/core'
import { ContextModalProps } from '@mantine/modals'
import { IconSend } from '@tabler/icons-react'
import { useSuspenseQuery } from '@tanstack/react-query'
import ShibaButton from 'common/ShibaButton'
import dayjs from 'dayjs'
import { getOrderQueryOptions, useSendEmail, useSendShipmentEmail } from 'hooks/orders'

type Props = {
  orderId: number
}

export default function OrderEmailsModal({ innerProps: { orderId } }: ContextModalProps<Props>) {
  const { data: order } = useSuspenseQuery(getOrderQueryOptions(orderId))
  const { mutateAsync: sendEmail, isPending: isSendingEmail } = useSendEmail()
  const { mutateAsync: sendShipmentEmail, isPending: isSendingShipmentEmail } = useSendShipmentEmail()

  return (
    <Container>
      <Table>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Rodzaj powiadomienia</Table.Th>
            <Table.Th>Data wysłania</Table.Th>
            <Table.Th></Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          <Table.Tr>
            <Table.Td>Potwierdzenie zamówienia</Table.Td>
            <Table.Td>
              {order.orderConfirmationSentAt
                ? dayjs(new Date(order.orderConfirmationSentAt)).format('D MMMM HH:mm')
                : 'Jeszcze nie wysłano'}
            </Table.Td>
            <Table.Td>
              <Button
                size="compact-sm"
                leftSection={<IconSend size={14} />}
                variant={order.orderConfirmationSentAt ? 'light' : 'filled'}
                onClick={() => sendEmail(order.id)}
                loading={isSendingEmail}
              >
                {order.orderConfirmationSentAt ? 'Wyślij ponownie' : 'Wyślij'}
              </Button>
            </Table.Td>
          </Table.Tr>
          {order.dispatchedAt && (
            <Table.Tr>
              <Table.Td>Potwierdzenie wysyłki</Table.Td>
              <Table.Td>
                {order.dispatchConfirmationSentAt
                  ? dayjs(new Date(order.dispatchConfirmationSentAt)).format('D MMMM HH:mm')
                  : 'Jeszcze nie wysłano'}
              </Table.Td>
              <Table.Td>
                <ShibaButton
                  size="compact-sm"
                  leftSection={<IconSend size={14} />}
                  variant={order.dispatchConfirmationSentAt ? 'light' : 'filled'}
                  onClick={() => sendShipmentEmail(order.id)}
                  loading={isSendingShipmentEmail}
                  disabledReason={
                    !order.trackingNumber
                      ? 'Nie można wysłać powiadomienia o wysyłce dla zamówienia bez numeru przesyłki'
                      : undefined
                  }
                >
                  {order.dispatchConfirmationSentAt ? 'Wyślij ponownie' : 'Wyślij'}
                </ShibaButton>
              </Table.Td>
            </Table.Tr>
          )}
        </Table.Tbody>
      </Table>
    </Container>
  )
}
